import { render } from "./ProductInventory.vue?vue&type=template&id=f458959c"
import script from "./ProductInventory.vue?vue&type=script&lang=js"
export * from "./ProductInventory.vue?vue&type=script&lang=js"
script.render = render

export default script